import { uniqStrings } from '../runner/utils';

/**
 * Filter only variable types and fix flow types.
 *
 * @param {EPTemplate} template
 * @returns {EPTemplatePartVariable}
 */
export function getTemplateVariableParts(template) {
  var variableParts = template.parts.filter(function (part) {
    return part.type === 'escaped' || part.type === 'unescaped';
  });
  return variableParts;
}

/**
 * Return the variables a template depends on.
 *
 * @param {EPTemplate} template
 * @return {Array<String>}
 */
export function getRequiredVariablesFromTemplate(template) {
  var variableParts = getTemplateVariableParts(template);
  var variableNames = variableParts.map(function (part) {
    return part.variableName;
  });
  return uniqStrings(variableNames);
}